import React, { useEffect, useState, useRef } from "react";
import TypingProps from "../types/TypingProps";
import TypingVoc from "../assets/keyboardTypingVoc.mp3";

const Typing: React.FC<TypingProps> = ({ text, speed = 56 }) => {
  const [displayedText, setDisplayedText] = useState("");
  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    const audio = new Audio(TypingVoc);
    audio.volume = 0.2;
    audioRef.current = audio;

    let i = 0;

    const interval = setInterval(() => {
      if (i < text.length - 1) {
        setDisplayedText((prev) => prev + text[i]);
        if (audioRef.current) {
          audioRef.current.currentTime = 0;
          audioRef.current.play().catch(() => {});
        }
        i++;
      } else {
        clearInterval(interval); 
        if (audioRef.current) {
          audioRef.current.pause();
          audioRef.current = null;
        }
      }
    }, speed);

    return () => {
        clearInterval(interval);
        if (audioRef.current) {
          audioRef.current.pause(); 
          audioRef.current.currentTime = 0; 
          audioRef.current = null; 
        }
    };
  }, [text, speed]);

  return <span>{displayedText}</span>;
};

export default Typing;